<template>
  <div>
    <div class="vld-parent">
      <Loading :active.sync="isLoading"
      :is-full-page="fullPage"></loading>
    </div>
    <div class="page-header">
      <h3>Log Book</h3>
    </div>

    <ul class="mt-2 list-group">
      <li v-for="activity in allActivities" :key="activity.id" class="list-group-item js-task-details-collapse-container">
        <Activity :activity="activity"/>
      </li>
    </ul>
  </div>
</template>

<script>
import api from "api";
import Activity from "components/Activity";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Activity,
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      allActivities: []
    }
  },
  created() {
    this.isLoading = true;
    return api.getActivities().then(response => {
      this.isLoading = false
      this.allActivities = response.data;
    });
  }
};
</script>
